import * as React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={84}
    height={75}
    viewBox={'0 0 84 75'}
    {...props}
    fill="none"
    stroke="none">
    <Circle cx={20.608} cy={9.295} r={9.295} fill={props.fill || '#005E38'} />
    <Circle cx={80.099} cy={47.717} r={3.718} fill={props.fill || '#005E38'} />
    <Path
      fill={props.fill || '#005E38'}
      d="M79.444 11.025c3.053 7.523-.57 16.097-8.093 19.15-.83.337-1.673.593-2.52.77-4.71.992-9.972 2.34-12.493 6.44-2.943 4.79-1.334 11.008 3.012 14.572 8.665 7.107 15.677 16.474 20.033 27.662 13.523 34.729-3.668 73.845-38.397 87.368-34.73 13.523-73.846-3.668-87.369-38.397-13.523-34.73 3.668-73.846 38.397-87.369 15.17-5.906 31.175-5.953 45.52-1.239 5.196 1.708 11.12.09 13.983-4.57l1.065-1.732c2.112-3.436 1.135-7.86-.381-11.598-3.054-7.523.57-16.097 8.093-19.15 7.523-3.053 16.097.57 19.15 8.093Z"
    />
  </Svg>
);
export default SvgComponent;
